<template>
  <v-dialog v-model="open" max-width="800px" persistent>
    <v-card>
      <v-progress-linear
        :active="isLoading"
        class="ma-0"
        color="secondary"
        indeterminate
        style="position: absolute; top: 0;"
      />
      <v-toolbar color="primary" dark flat tabs>
        <v-toolbar-title>Manage Content</v-toolbar-title>
        <v-spacer />
        <v-tabs slot="extension" v-model="page" dark grow slider-color="primary">
          <v-tab v-for="(tab, index) in allowedTabs" :key="index" :href="`#tab-${index}`">
            {{ tab.title }}
          </v-tab>
        </v-tabs>
      </v-toolbar>
      <v-tabs-items v-model="page">
        <v-tab-item v-for="(tab, index) in allowedTabs" :key="index" :value="`tab-${index}`">
          <slot name="form-dialog" />
          <component
            :is="tab.component"
            :data="values"
            @canSubmit="canSubmit"
            @cancel="toggleDialog"
            @close="toggleDialog"
            @data-dialog="saveValues"
          />
          <v-card-actions v-if="tab.selfAction === false">
            <v-spacer />
            <v-btn depressed @click="toggleDialog">
              Close
            </v-btn>
            <v-btn
              :disabled="submitDisabled"
              :loading="isLoading"
              color="primary"
              depressed
              @click="submit(tab.action)"
            >
              Create
            </v-btn>
          </v-card-actions>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import { DIALOG_FORM, ROLES, TOGGLE_DIALOG } from '../../config/constants';
import { intersection } from 'lodash';
import AddSlideForm from './forms/AddSlideForm';
import AddFlowForm from './forms/AddFlowForm';
import AddChapterForm from './forms/AddChapterForm';
import ImportTasks from './forms/ImportTasks';
import AddCycleForm from '@/components/dialogs/forms/AddCycleForm';
import AddReference from '@/components/dialogs/forms/AddReference';

export default {
  name: 'DialogContainer',
  components: { ImportTasks, AddChapterForm, AddFlowForm, AddSlideForm, AddCycleForm, AddReference },
  props: {
    roles: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      page: 'tab-0',
      values: {},
      isLoading: false,
      submitDisabled: true
    };
  },
  watch: {
    values: {
      handler(values) {
        if (values.name || values.text) {
          this.canSubmit();
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapState('navigation', {
      open: state => state.dialog.open
    }),
    allowedTabs() {
      const list = DIALOG_FORM;
      return list.filter(item => {
        if (this.roles) {
          if (this.roles.includes(ROLES.ADMIN)) {
            return true;
          }
        }

        return intersection(item.roles, this.roles).length > 0;
      });
    }
  },
  methods: {
    async toggleDialog() {
      await this.$store.dispatch(TOGGLE_DIALOG);
    },
    saveValues(values) {
      this.values = values;
    },
    clear(values) {
      const obj = {};
      for (const key in values) {
        if (values.hasOwnProperty(key)) {
          // @ts-ignore
          if (!values[key]) {
            continue;
          }
          // @ts-ignore
          obj[key] = values[key];
        }
      }
      return obj;
    },
    empty() {
      this.values = {};
    },
    submit(action) {
      this.isLoading = true;
      return this.$store
        .dispatch(action, this.clear(this.values))
        .then(async id => {
          this.empty();
          this.isLoading = false;
          await this.$store.dispatch(TOGGLE_DIALOG);
          // TODO: If erstellt dann?
          // return this.$router.push('/database/slide/' + id);
        })
        .catch(er => (this.isLoading = false));
    },
    canSubmit() {
      this.submitDisabled = false;
    }
  }
};
</script>

<style>
.v-window__container {
  min-height: 100%;
}
</style>
